import classNames from 'classnames';
import { useState } from 'react';

import ProvisionProject from './ProvisionProject';
import StandardACLForm from './StandardACLForm';

// 'choose' is the first screen (confidential vs standard); the other two render the
// matching form body. The form components own their own state, so gating their render
// on showModal means they remount — and reset — each time the modal is reopened.
type Mode = 'choose' | 'confidential' | 'standard';

// Entry point for creating an ACL group. Replaces the old standalone "New confidential
// project" button: opens a modal that first asks whether this is a confidential project,
// then routes to the confidential provisioning flow or the standard ACL form.
export default function CreateACLGroup() {
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState<Mode>('choose');

  const handleOpen = () => {
    setMode('choose');
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const modalClassName = classNames('modal fixed inset-0 flex items-center justify-center', {
    'modal-open': showModal,
  });

  return (
    <>
      <button className="btn btn-secondary" onClick={handleOpen}>
        Create ACL
      </button>

      <div className={modalClassName}>
        <div className="bg-base-100 rounded-lg p-5 w-full max-w-lg">
          {showModal && mode === 'choose' && (
            <>
              <div className="font-bold text-xl mb-4">Create ACL</div>
              <p className="text-sm mb-4">Is this for a confidential project?</p>
              <div className="flex flex-col gap-2 mb-4">
                <button
                  className="btn btn-outline h-auto py-3 flex-col items-start normal-case"
                  onClick={() => setMode('confidential')}
                >
                  <span className="font-bold">Confidential project</span>
                  <span className="text-xs font-normal text-base-content/60">
                    Builds the ACL + Role pair and enables on-prem writeback
                  </span>
                </button>
                <button
                  className="btn btn-outline h-auto py-3 flex-col items-start normal-case"
                  onClick={() => setMode('standard')}
                >
                  <span className="font-bold">Standard ACL</span>
                  <span className="text-xs font-normal text-base-content/60">
                    Create a single ACL_ group with an optional writeback toggle
                  </span>
                </button>
              </div>
              <div className="flex justify-end">
                <button className="btn btn-ghost" onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </>
          )}
          {showModal && mode === 'confidential' && (
            <ProvisionProject onClose={handleClose} onBack={() => setMode('choose')} />
          )}
          {showModal && mode === 'standard' && (
            <StandardACLForm onClose={handleClose} onBack={() => setMode('choose')} />
          )}
        </div>
      </div>
    </>
  );
}
